export const color_01 = "#ff9ea3"
export const color_02 = "#e61e28"
